import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { globalConfig } from '../utils/globalConfig';
import { AuthService } from 'src/app/modules/auth/auth.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (sessionStorage.getItem(globalConfig.tokenApi)) {
            this.authService.toastMessage = 'Su sesión ha expirado, por favor ingrese a la plataforma nuevamente.';
          }
          sessionStorage.removeItem(globalConfig.tokenApi);
          this.router.navigate(['/auth/sign-in']);
        }
        return throwError(() => error);
      }),
    );
  }
}
